/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import styled from 'styled-components';
import { BASE_BORDER_WIDTH, STACK_DIRECTION, STACK_GAP, StackView, Text } from '@veeam/components';

import type { CSSProperties } from 'react';

import { FieldsetSectionGrid } from '../FieldsetSectionGrid';

import type { FieldsetSectionRowProps } from '../FieldsetSectionRow';

export interface FieldsetSectionsProps {
    title?: React.ReactNode;
    titleStyles?: CSSProperties;
    items: FieldsetSectionRowProps[];
    itemsStyles?: CSSProperties;
}

const FieldsetSectionBase = styled(StackView)`
    border-right: ${BASE_BORDER_WIDTH} solid ${({ theme }) => theme.colorBorderMain};

    &:last-child {
        border-right: none;
    }
`;

export const FieldsetSection: React.FC<FieldsetSectionsProps> = ({ title, titleStyles, items, itemsStyles }) => (
    <FieldsetSectionBase direction={STACK_DIRECTION.column} gap={STACK_GAP.s}>
        {title && <Text style={{ fontWeight: 'bold', ...titleStyles }}>{title}</Text>}
        <FieldsetSectionGrid items={items} itemsStyles={itemsStyles} />
    </FieldsetSectionBase>
);
